import { apiService } from './api';
import { CropType, CreateCropTypeDto, UpdateCropTypeDto } from '../types/cropTypes';

export const cropTypesService = {
  // Get all crop types
  getAll: async () => {
    return apiService.get<CropType[]>('/croptypes');
  },

  // Get crop type by ID
  getById: async (id: number) => {
    return apiService.get<CropType>(`/croptypes/${id}`);
  },

  // Create new crop type
  create: async (data: CreateCropTypeDto) => {
    return apiService.post<CropType>('/croptypes', data);
  },

  // Update crop type
  update: async (id: number, data: UpdateCropTypeDto) => {
    return apiService.put<CropType>(`/croptypes/${id}`, data);
  },

  // Delete crop type
  delete: async (id: number) => {
    return apiService.delete<void>(`/croptypes/${id}`);
  },

  // Search crop types
  search: async (searchTerm: string) => {
    return apiService.get<CropType[]>(`/croptypes/search?searchTerm=${encodeURIComponent(searchTerm)}`);
  },
};